import type { LinkProps } from '@packages/shared';
import { useRouter } from 'next/router';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { UseSearchResultDataForCategoryFilterFragmentFragmentDoc } from '@packages/gql/generated/shopping/UseSearchResultDataForCategoryFilterFragmentFragmentDoc';
import type { CategoryFilterItem } from '../CategoryFilterStandalone';

/* GraphQL */ `
  fragment UseSearchResultDataForCategoryFilterFragment on SuccessfulSearchResult {
    categories {
      id
      name
      level
      isSelected
      isParentSelected
      styleCount
    }
  }
`;

export const useSearchResultDataForCategoryFilter = (
  maskedData: FragmentType<typeof UseSearchResultDataForCategoryFilterFragmentFragmentDoc>,
): CategoryFilterItem[] => {
  const {
    pathname,
    query: { c, ...otherQueryParameters },
  } = useRouter();

  const data = getFragmentData(UseSearchResultDataForCategoryFilterFragmentFragmentDoc, maskedData);

  const generateCategoryHref = (categoryId: string) =>
    ({
      pathname,
      query: { ...otherQueryParameters, c: categoryId },
    }) as LinkProps['href'];

  return data.categories.map(
    ({ id, name, level, styleCount, isParentSelected, isSelected = false }) => {
      const isSelectedExact = isSelected !== null ? isSelected : false;

      return {
        id,
        name,
        level,
        count: styleCount ?? undefined,
        href: generateCategoryHref(id),
        isSelected: isParentSelected || isSelectedExact,
        isSelectedExact,
      };
    },
  );
};
